import { Navigate } from '@tanstack/react-router'
import type { ReactNode } from 'react'

interface FlagGatedSectionProps {
	enabled: boolean
	companyId: string
	campaignId: string
	children: ReactNode
}

/** Renders a campaign-settings section only when its feature flag is on;
 * otherwise sends the user back to the settings index (which picks the first
 * enabled section or shows the empty state). Mirrors the RequireAccess gate. */
export function FlagGatedSection({ enabled, companyId, campaignId, children }: FlagGatedSectionProps) {
	if (!enabled) {
		return (
			<Navigate to="/company/$companyId/$campaignId/settings" params={{ companyId, campaignId }} replace={true} />
		)
	}

	return <>{children}</>
}
